import api from './api';

/**
 * Upload a PDF resume for parsing
 * @param {File} file - PDF file
 * @param {string} name - Optional name for the resume
 */
export const uploadResume = async (file, name = '') => {
  const formData = new FormData();
  formData.append('file', file);
  if (name) {
    formData.append('name', name);
  }

  const response = await api.post('/resumes/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  return response.data;
};

/**
 * Create a resume manually
 * @param {Object} data - Resume data
 */
export const createResume = async (data) => {
  const response = await api.post('/resumes', data);
  return response.data;
};

/**
 * Get all resumes
 */
export const getResumes = async () => {
  const response = await api.get('/resumes');
  return response.data;
};

/**
 * Get a single resume
 * @param {string} id - Resume ID
 */
export const getResume = async (id) => {
  const response = await api.get(`/resumes/${id}`);
  return response.data;
};

/**
 * Update a resume
 * @param {string} id - Resume ID
 * @param {Object} data - Updated data
 */
export const updateResume = async (id, data) => {
  const response = await api.put(`/resumes/${id}`, data);
  return response.data;
};

/**
 * Delete a resume
 * @param {string} id - Resume ID
 */
export const deleteResume = async (id) => {
  const response = await api.delete(`/resumes/${id}`);
  return response.data;
};

/**
 * Set a resume as default
 * @param {string} id - Resume ID
 */
export const setDefaultResume = async (id) => {
  const response = await api.post(`/resumes/${id}/default`);
  return response.data;
};

/**
 * Re-parse a resume
 * @param {string} id - Resume ID
 */
export const reparseResume = async (id) => {
  const response = await api.post(`/resumes/${id}/reparse`);
  return response.data;
};

export default {
  uploadResume,
  createResume,
  getResumes,
  getResume,
  updateResume,
  deleteResume,
  setDefaultResume,
  reparseResume
};
